<template>
  <v-card>
    <v-form v-model="valid" ref="form" autocomplete="off">
      <v-container>
        <v-alert type="error" class="mb-2" v-for="error in errorMessages" :key="error.message">
          {{ error.message }}
        </v-alert>
        <v-row dense>
          <v-col cols="9">
            <v-btn @click="add">Add Relationship</v-btn>
          </v-col>
        </v-row>
        <div v-for="(criterion, index) in relationship.criteria" :key="criterion.clientId" justify="center">
          <v-row dense>
            <v-col class="col-5">
              <QuestionChooser
                v-model="criterion.questionId"
                @onSelect="cleanValue(criterion)"
                :question="getCurrentQuestion(criterion)"
                :list="questions"
              />
            </v-col>
            <v-col class="col-5">
              <AnswerChooser v-model="criterion.valueId" :answer="getCurrentValue(criterion)" :list="getValues(criterion)" />
            </v-col>
            <v-col class="col-2 remove">
              <a href="#" @click.prevent="remove(criterion)" class="black-link">Remove</a>
            </v-col>
          </v-row>
          <span v-if="index + 1 !== relationship.criteria.length">and</span>
        </div>
        <slot :relationship="relationship"></slot>
        <v-card-actions>
          <v-row justify="end">
            <v-btn color="success" :disabled="!valid" @click="save">Save</v-btn>
            <v-btn @click="cancel">Cancel</v-btn>
          </v-row>
        </v-card-actions>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import QuestionChooser from './QuestionChooser'
import AnswerChooser from './AnswerChooser'
import shortid from 'shortid'

export default {
  name: 'QAChooser',
  props: {
    qaList: Array,
    relationship: Object,
    relationships: Array
  },
  components: {
    QuestionChooser,
    AnswerChooser
  },
  data() {
    return {
      errorMessages: [],
      valid: false
    }
  },
  computed: {
    questions() {
      const original = this.qaList
        .filter(({ parentQuestion }) => {
          return parentQuestion.values && parentQuestion.values.length
        })
        .map(({ parentQuestion }) => {
          return {
            ...parentQuestion,
            values: parentQuestion.values.map(v => {
              return {
                ...v,
                fullLabel: (v.enabled ? '' : '(Disabled) ') + v.label
              }
            })
          }
        })

        const results = []
        original.forEach(o => {
          if (!results.some(r => r.id === o.id && r.label === o.label)){
            results.push(o)
          }
        })
        return results
    }
  },
  methods: {
    add() {
      this.relationship.criteria.push({
        clientId: shortid.generate(),
        questionId: '',
        valueId: ''
      })
    },
    remove(criterion) {
      this.relationship.criteria = this.relationship.criteria.filter(r => r.clientId !== criterion.clientId)
    },
    getValues(criterion) {
      const question = this.questions.find(q => q.clientId === criterion.questionId)
      if (question) {
        const selectedValues = this.relationship.criteria
          .filter(c => {
            return criterion.clientId !== c.clientId && c.questionId === question.clientId
          })
          .map(c => c.valueId)

        return question.values ? question.values.filter(v => !selectedValues.includes(v.clientId)) : []
      }

      return []
    },
    getCurrentQuestion(criterion) {
      const question = this.questions.find(q => q.clientId === criterion.questionId)
      return question
    },
    getCurrentValue(criterion) {
      const question = this.questions.find(q => q.clientId === criterion.questionId)
      if (question) {
        return question.values.find(v => v.clientId === criterion.valueId) || {}
      }

      return undefined
    },
    save() {
      const results = this.validate().filter(v => !v.success)
      if (results.length) {
        this.errorMessages = results
        return
      }
      this.errorMessages = []
      this.$emit('save', this.relationship)
    },

    validate() {
      return [
        {
          success: this.validateDuplicateCriteria(),
          message: 'Same combination of response relationship already exists'
        },
        {
          success: this.validateAtLeastOneFAT(),
          message: 'Please choose at least one Approver, FYI or Task'
        },
        {
          success: this.validateAtLeastOneCriteria(),
          message: 'Please add at least one valid relationship'
        }
      ]
    },
    validateDuplicateCriteria() {
      if (!this.relationship.criteria.length) return true
      const notMeRelationships = this.relationships.filter(r => this.relationship.clientId !== r.clientId)
      for (let r of notMeRelationships) {
        const notMeCriteria = this.$_.orderBy(r.criteria.map(c => `${c.questionId},${c.valueId}`))
        const criteria = this.$_.orderBy(this.relationship.criteria.map(c => `${c.questionId},${c.valueId}`))
        if (notMeCriteria.length !== criteria.length) continue
        let count = 0
        for (var i = 0; i < notMeCriteria.length; ++i) {
          if (notMeCriteria[i] !== criteria[i]) continue
          count++
        }
        if (count === criteria.length) return false
      }

      return true
    },
    validateAtLeastOneFAT() {
      return this.relationship.approvers.length > 0 || this.relationship.fyis.length > 0 || this.relationship.tasks.length > 0
    },
    validateAtLeastOneCriteria() {
      if (this.relationship.criteria.length <= 0) return false
      if (!this.relationship.criteria[0].questionId || !this.relationship.criteria[0].valueId) return false
      return true
    },
    cancel() {
      this.$emit('cancel')
    },
    cleanValue(criterion) {
      criterion.valueId = ''
    }
  }
}

// TODO: Prevent or warn user about deletion of associated items (fields, responses, tasks)
// TODO: Improve response relationship search
</script>
<style scoped>
.remove {
  display: flex;
  align-items: center;
}
.black-link {
  color: #000000;
}

</style>
